import React from 'react';
import { subscribe, clearSaveFailed } from '../lib/saveFailed';

/*
  "That did not save."

  **Built 10 September 2026 for job 25**, to Group H's approved drawing
  `offline-desk`. It is the same bar as the connection bar in count entry,
  wearing different words, which is deliberate: a person who has seen one on a
  phone recognises the other on a desk.

  **Gold, like the held bar.** Something is not right and you should know, but
  you are not stopped and nothing has been lost off the screen. It sits under
  the page bar and above the work, so nothing a person is reading moves out from
  under them.

  **The button is the reason it exists.** A pop-up message that goes on its own
  after five seconds is right for something you only need to be told and wrong
  for something you have to do.
*/
export default function SaveFailedBar() {
  const [failure, setFailure] = React.useState(null);
  const [trying, setTrying] = React.useState(false);

  React.useEffect(() => subscribe(setFailure), []);

  if (!failure) return null;

  async function again() {
    setTrying(true);
    try {
      /* **Cleared only when the retry says it worked.** Clearing first would
         make a second failure look like a first, and a bar that flickers away
         and back reads as OnHand losing track of itself. A retry that answers
         nothing is treated as having worked, because it did not say otherwise
         and the caller will raise a fresh bar if it failed again. */
      const ok = await failure.retry();
      if (ok !== false) clearSaveFailed();
    } finally {
      setTrying(false);
    }
  }

  return (
    <div className="conn-bar hold" role="alert">
      <span className="conn-bar-i">
        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" aria-hidden="true"
          stroke="var(--on-action)" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
          <path d="M17.5 18H7a4 4 0 0 1-.6-7.96A6 6 0 0 1 17.7 8.2" /><path d="M3 3l18 18" />
        </svg>
      </span>
      <div className="conn-bar-words">
        <div className="conn-bar-t">
          {failure.what ? `${failure.what} did not save.` : 'That did not save.'}
        </div>
        <div className="conn-bar-s">The connection dropped. Nothing was lost off the screen.</div>
      </div>
      <button type="button" className="conn-bar-act" disabled={trying} onClick={again}>
        {trying ? 'Trying...' : 'Try again'}
      </button>
    </div>
  );
}
